import React from 'react';
import {
  MessageSimple,  
} from 'stream-chat-react';
 
// ✅ Custom Message using MessageSimple
const CustomMessage = (props) => {
  return (
    <MessageSimple
      {...props}      
    />
  );
};
export default CustomMessage;
